export default __webpack_public_path__ + "static/media/walet.ccef482c.svg";